<ng-container>
    <div class="dropdown-wrapper">
        <ham-button
            #datePickerButton
            class="date-button"
            size="lg"
            [variant]="selectedYears?.length ? 'transparent' : 'white'"
            [outline]="true"
            rightIcon="assets/hamIcons/chevron-down.svg"
            (click)="openFlyout(datePickerButton)"
            ><span class="filter-number" *ngIf="selectedYears?.length"> {{ selectedYears?.length }} </span>
            {{ translationKeyFilterName | i18next }}
        </ham-button>
    </div>
</ng-container>

<span class="menu-flyout" hamFlyout *ngIf="openedFlyout" [position]="flyoutPosition" (closeFlyout)="closeFlyout()">
    <div class="flyout-scroll-wrapper">
        <div class="flyout-user-options-content">
            <div *ngFor="let year of options">
                <label class="custom-checkbox user-option">
                    <input
                        type="checkbox"
                        [checked]="selectedOptionIds?.includes(year)"
                        (change)="onPeriodSelection(year, $event.target.checked)"
                    />

                    <label class="option" (click)="$event.stopPropagation(); toggleUserSelection(year)">
                        <span class="name">{{ year }}</span>
                    </label>
                </label>
            </div>
        </div>
    </div>
    <div class="filter-actions">
        <ham-button variant="teal" size="sm" (click)="applyFilter()">{{
            'aumico_pm_tasks_apply_filter' | i18next
        }}</ham-button>
        <ham-button variant="white" size="sm" (click)="clearFilter()">{{
            'aumico_pm_tasks_clear_filter' | i18next
        }}</ham-button>
    </div>
</span>
